<div class="template-builder-layout" *ngIf="templateForm">
  <div class="left-panel">
    <form class="itinerary-model-content-inner" [formGroup]="templateForm">
      <div class="itinerary-model-content">
        <div class="form-container">

          <!-- Template Details -->
          <div class="ion-no-padding">
            <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">
              Template Details
            </ion-title>
          </div>

          <div class="form-container ion-padding-horizontal">
            <div class="row">

              <div class="col-4">
                <div class="input-container">
                  <label class="label">Template Name*</label>
                  <input class="input" type="text" formControlName="name" placeholder="Template Name" />
                </div>
              </div>

              <div class="col-4">
                <div class="input-container">
                  <label class="label">Template Category*</label>
                  <select class="input" formControlName="templateCategory">
                    <option value="" hidden>-- Select Category --</option>
                    <option value="MARKETING">Marketing</option>
                    <option value="TRANSACTIONAL">Transactional</option>
                  </select>
                </div>
              </div>

              <div class="col-4">
                <div class="input-container">
                  <label class="label">Language*</label>
                  <select class="input" formControlName="language">
                    <option value="" hidden>-- Select Language --</option>
                    <option value="en">English</option>
                    <option value="hi">Hindi</option>
                  </select>
                </div>
              </div>

            </div>
          </div>

          <!-- Template Types -->
          <div class="ion-no-padding mt-2">
            <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">
              Template Types
            </ion-title>
          </div>

          <div class="form-container ion-padding-horizontal">

            <div class="radio-group">
              <div class="input-container">
                <input type="radio" formControlName="templateType" value="none" />
                <label class="label">None</label>
              </div>

              <div class="input-container">
                <input type="radio" formControlName="templateType" value="text" />
                <label class="label">Text</label>
              </div>

              <div class="input-container">
                <input type="radio" formControlName="templateType" value="image" />
                <label class="label">Image</label>
              </div>

              <div class="input-container">
                <input type="radio" formControlName="templateType" value="video" />
                <label class="label">Video</label>
              </div>

              <div class="input-container">
                <input type="radio" formControlName="templateType" value="document" />
                <label class="label">Document</label>
              </div>
            </div>

            <!-- Text Header -->
            <div *ngIf="templateForm.get('templateType')?.value === 'text'">
              <div class="col-12">
                <div class="input-container">
                  <label class="label">Header Text</label>
                  <input class="input" type="text" formControlName="headerText" placeholder="Enter header text" />
                </div>
              </div>
            </div>

            <!-- Image Upload -->
            <div *ngIf="templateForm.get('templateType')?.value === 'image'">
              <div class="row" style="display:flex;flex-direction:column;align-items:center;">

                <div class="col-12" *ngIf="!preview.image">
                  <div class="input-container">
                    <label class="label">Upload Image</label>
                    <div class="upload-box hero-upload">
                      <label class="hero-upload-btn">
                        <ion-icon name="cloud-upload-outline"></ion-icon>
                        <span>Upload Image</span>
                        <input type="file" accept="image/*" (change)="onFileSelected($event,'image')" />
                      </label>
                    </div>
                  </div>
                </div>

                <div *ngIf="preview.image" class="preview text-center">
                  <img [src]="preview.image" style="max-width:100%;border-radius:8px;" />
                  <div class="mt-2 flex gap-2 justify-content-end">
                    <button type="button" class="reupload" (click)="reupload('image')">Reupload</button>
                    <button type="button" class="remove" (click)="removeMedia('image')">Remove</button>
                  </div>
                </div>

              </div>
            </div>

            <!-- Video Upload -->
            <div *ngIf="templateForm.get('templateType')?.value === 'video'">
              <div class="row" style="display:flex;flex-direction:column;">

                <div class="col-12" *ngIf="!preview.video">
                  <div class="input-container">
                    <label class="label">Upload Video</label>
                    <div class="upload-box hero-upload">
                      <label class="hero-upload-btn">
                        <ion-icon name="cloud-upload-outline"></ion-icon>
                        <span>Upload Video</span>
                        <input type="file" accept="video/*" (change)="onFileSelected($event,'video')" />
                      </label>
                    </div>
                  </div>
                </div>

                <div *ngIf="preview.video" class="preview text-center">
                  <video [src]="preview.video" controls style="max-width:100%;border-radius:8px;"></video>
                  <div class="mt-2 flex gap-2 justify-center">
                    <button type="button" class="reupload" (click)="reupload('video')">Reupload</button>
                    <button type="button" class="remove" (click)="removeMedia('video')">Remove</button>
                  </div>
                </div>

              </div>
            </div>

            <!-- Document Upload -->
            <div *ngIf="templateForm.get('templateType')?.value === 'document'">
              <div class="row" style="display:flex;flex-direction:column;">

                <div class="col-12" *ngIf="!preview.document">
                  <div class="input-container">
                    <label class="label">Upload Document</label>
                    <div class="upload-box hero-upload">
                      <label class="hero-upload-btn">
                        <ion-icon name="cloud-upload-outline"></ion-icon>
                        <span>Upload Document</span>
                        <input type="file" accept=".pdf,.doc,.docx,.txt" (change)="onFileSelected($event,'document')" />
                      </label>
                    </div>
                  </div>
                </div>

                <div *ngIf="preview.document" class="preview text-center">

                  <iframe *ngIf="documentType === 'pdf'" [src]="preview.document" width="100%" height="400px"
                    style="border:none;border-radius:8px;">
                  </iframe>

                  <div *ngIf="documentType !== 'pdf'">
                    <a [href]="preview.document" target="_blank">Open Document</a>
                  </div>

                  <div class="mt-2 flex gap-2 justify-center">
                    <button type="button" class="reupload" (click)="reupload('document')">Reupload</button>
                    <button type="button" class="remove" (click)="removeMedia('document')">Remove</button>
                  </div>

                </div>

              </div>
            </div>

          </div>

          <!-- Body -->
          <div class="ion-no-padding mt-2">
            <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">
              Body Text
            </ion-title>
          </div>

          <div class="form-container ion-padding-horizontal">
            <div class="input-container">
              <label class="label">Body Text*</label>
              <app-whatsapp-text-editor formControlName="body"
                placeholder="Write your message"></app-whatsapp-text-editor>
            </div>
          </div>

          <!-- Footer -->
          <div class="ion-no-padding mt-2">
            <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">
              Footer
            </ion-title>
          </div>

          <div class="form-container ion-padding-horizontal">
            <div class="input-container">
              <label class="label">Footer</label>
              <textarea class="input" rows="3" formControlName="footer" placeholder="Footer text"></textarea>
            </div>
          </div>

          <!-- Buttons -->
          <div class="ion-no-padding mt-2">
            <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">
              Buttons
            </ion-title>
          </div>

          <div class="form-container ion-padding-horizontal">
            <div class="radio-group">

              <div class="input-container">
                <input type="radio" formControlName="buttonType" value="none" />
                <label class="label">None</label>
              </div>

              <div class="input-container">
                <input type="radio" formControlName="buttonType" value="call" />
                <label class="label">Call to Action</label>
              </div>

              <div class="input-container">
                <input type="radio" formControlName="buttonType" value="quick" />
                <label class="label">Quick Reply</label>
              </div>

            </div>
          </div>

          <!-- CALL BUTTONS -->
          <div *ngIf="templateForm.get('buttonType')?.value === 'call'" formArrayName="callButtons"
            class="ion-padding-horizontal">

            <div class="row align-items-end mb-2" *ngFor="let btn of callButtons.controls; let i = index"
              [formGroupName]="i">

              <!-- Action Type -->
              <div class="col-3">
                <div class="input-container">
                  <label class="label">Action Type</label>
                  <select class="input" formControlName="actionType">
                    <option value="Call Us">Call Us</option>
                    <option value="Visit Website">Visit Website</option>
                  </select>
                </div>
              </div>

              <!-- URL -->
              <div class="col-4">
                <div class="input-container">
                  <label class="label">URL</label>
                  <input class="input" type="text" formControlName="url" placeholder="https://example.com" />
                </div>
              </div>

              <!-- Button Text -->
              <div class="col-3">
                <div class="input-container">
                  <label class="label">Button Text</label>
                  <input class="input" type="text" formControlName="text" maxlength="20" placeholder="Button text" />
                </div>
              </div>

              <!-- RIGHT SIDE: ✕ and + Add Button -->
              <div class="col-2 d-flex justify-content-end align-items-center gap-2">

                <!-- Remove -->
                <button type="button" class="remove-btn" (click)="removeCallButton(i)">
                  ✕
                </button>

                <!-- Add Button: visible only on last item -->
                <ion-button class="filled-blue-btn" *ngIf="i === callButtons.length - 1" (click)="addCallButton()">
                  + Add
                </ion-button>

              </div>

            </div>

          </div>


          <!-- QUICK REPLY BUTTONS -->
          <div *ngIf="templateForm.get('buttonType')?.value === 'quick'" class="ion-padding-horizontal"
            formArrayName="quickReplies">

            <div class="row align-items-end mb-2" *ngFor="let reply of quickReplies.controls; let i=index"
              [formGroupName]="i">

              <!-- Quick Reply Text -->
              <div class="col-6">
                <div class="input-container">
                  <label class="label">Quick Reply Text</label>
                  <input class="input" type="text" formControlName="text" maxlength="20"
                    placeholder="Enter quick reply" />
                </div>
              </div>

              <!-- Right side: ✕ and +Add -->
              <div class="col-6 d-flex justify-content-end align-items-center gap-2">

                <!-- REMOVE button -->
                <button type="button" class="remove-btn" (click)="removeQuickReply(i)">
                  ✕
                </button>

                <!-- ADD button (only on last Quick Reply row) -->
                <ion-button *ngIf="i === quickReplies.length - 1" class="filled-blue-btn small-add-btn"
                  (click)="addQuickReply()">
                  + Add
                </ion-button>

              </div>

            </div>

          </div>

        </div>
      </div>
    </form>
  </div>
</div>